/**
 * Minimal class-name combiner. Filters falsy values and joins with a space.
 * Intentionally lighter than `clsx` — we don't need conditional-object syntax
 * and adding a dependency for 12 lines of code isn't worth it.
 */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
